export var AlertAttributeTypes;
(function (AlertAttributeTypes) {
    AlertAttributeTypes["ReminderDueDays"] = "reminderDueDays";
    AlertAttributeTypes["PromoExpiryDays"] = "promoExpiryDays";
    AlertAttributeTypes["AvailableCreditThresholdAmount"] = "availableCreditThresholdAmount";
    AlertAttributeTypes["BalanceExceedsThresholdAmount"] = "balanceExceedsThresholdAmount";
    AlertAttributeTypes["PurchaseExceedsThresholdAmount"] = "purchaseExceedsThresholdAmount";
    AlertAttributeTypes["ApprovedTransactionType"] = "approvedTransactionType";
    AlertAttributeTypes["GenerousTipPercentage"] = "thresholdPercentage";
})(AlertAttributeTypes || (AlertAttributeTypes = {}));
export var AlertDeliveryTypes;
(function (AlertDeliveryTypes) {
    AlertDeliveryTypes["Email"] = "email";
    AlertDeliveryTypes["Text"] = "text";
})(AlertDeliveryTypes || (AlertDeliveryTypes = {}));
